var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-title"},[_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],attrs:{"data-src":require("assets/images/courses/titleLine.png"),"alt":""}}),_vm._v(" "),_c('span',{staticClass:"font-semibold"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }